import { AllNbisivPermission } from "presentation/constant/ANAInfo/NbisivPermission";
import { useAuditTrailReportVM } from "presentation/hook/AuditTrailReport/useAuditTrailReportVM";
import { useANAInfoTracked } from "presentation/store/ANAInfo";
import { memo, useEffect, useState } from "react";
import { Loader } from "veronica-ui-component/dist/component/core";
import AuditTrailReportPanel from "./AuditTrailReportPanel";


const AuditTrailReportMaintenance: React.FC = () => {
    const [isLoading, setIsLoading] = useState(true);
    const auditTrailReportVM = useAuditTrailReportVM();

    const [anaInfoState] = useANAInfoTracked();
    const { allNbisivPermission } = anaInfoState;

    useEffect(() => {
        const initialScreen = async () => {
            try {
                const results = await Promise.allSettled([
                    auditTrailReportVM.loadDropdownOption(),
                ]);
                results?.forEach((result, index) => {
                    if (index === 0 && result.status === 'fulfilled') {

                    }
                })
            } catch (error) {
                setIsLoading(false);
            }
        }
        initialScreen().then((data) => {
            auditTrailReportVM.initAuditTrailReportList(allNbisivPermission as AllNbisivPermission).then((data) => {
                setIsLoading(false)
            }).catch(error => {
                setIsLoading(false)
            });
        }).catch(error => {
            setIsLoading(false)
        });

    }, [auditTrailReportVM, allNbisivPermission])

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper im-hide-side-form-draggable`}>
            {<>
                <AuditTrailReportPanel /></>}
        </div>
    </>
}

export default memo(AuditTrailReportMaintenance);